import { render, staticRenderFns } from "./BraindatePopup.vue?vue&type=template&id=2ebfaea4&scoped=true&"
import script from "./BraindatePopup.vue?vue&type=script&lang=js&"
export * from "./BraindatePopup.vue?vue&type=script&lang=js&"
import style0 from "./BraindatePopup.vue?vue&type=style&index=0&id=2ebfaea4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ebfaea4",
  null
  
)

/* custom blocks */
import block0 from "./BraindatePopup.vue?vue&type=custom&index=0&blockType=translations"
if (typeof block0 === 'function') block0(component)

export default component.exports